(function () {
  if (window.AnywellAttribution && window.AnywellAttribution.version === "20260607") return;

  var STORAGE_KEY = "aw_attribution_v1";
  var COOKIE_DAYS = 30;
  var SYNC_TTL_MS = 10000;
  var UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_product",
    "utm_phase",
    "utm_angle",
    "fbclid",
    "gclid"
  ];
  var CART_ATTRIBUTE_KEYS = [
    "first_landing_url",
    "first_landing_path",
    "first_landing_at",
    "first_referrer_url",
    "first_product_handle",
    "last_landing_url",
    "last_landing_path",
    "last_referrer_url",
    "first_ad_landing_url",
    "first_ad_landing_path",
    "first_ad_landing_at",
    "first_ad_referrer_url",
    "first_ad_product_handle",
    "last_ad_landing_url",
    "last_ad_landing_path",
    "last_ad_landing_at",
    "last_ad_referrer_url",
    "last_ad_product_handle",
    "last_product_handle",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_product",
    "utm_phase",
    "utm_angle",
    "fbclid",
    "gclid",
    "first_utm_source",
    "first_utm_medium",
    "first_utm_campaign",
    "first_utm_content",
    "first_utm_term",
    "first_utm_product",
    "first_utm_phase",
    "first_utm_angle",
    "first_fbclid",
    "first_gclid",
    "last_utm_source",
    "last_utm_medium",
    "last_utm_campaign",
    "last_utm_content",
    "last_utm_term",
    "last_utm_product",
    "last_utm_phase",
    "last_utm_angle",
    "last_fbclid",
    "last_gclid"
  ];

  function nowIso() {
    return new Date().toISOString();
  }

  function safeString(value, maxLength) {
    return String(value || "").trim().slice(0, maxLength || 500);
  }

  function readParams() {
    var params = {};
    try {
      var search = new URLSearchParams(window.location.search || "");
      UTM_KEYS.forEach(function (key) {
        var value = search.get(key);
        if (value) params[key] = safeString(value, key === "fbclid" || key === "gclid" ? 300 : 180);
      });
    } catch (error) {}
    return params;
  }

  function hasAttributionParams(params) {
    return UTM_KEYS.some(function (key) {
      return Boolean(params[key]);
    });
  }

  function productHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function inferUtmProduct(handle) {
    var value = String(handle || window.location.pathname || "").toLowerCase();
    if (/x-?024|x024/.test(value)) return "x024";
    if (/ys12|pgpw00004/.test(value)) return "ys12";
    if (/ys16|pgpw00006|wide-seat-power-wheelchair|150kg-capacity-electric-wheelchair/.test(value)) return "ys16max";
    return "";
  }

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY) || "";
      if (!raw) raw = decodeURIComponent(readCookie(STORAGE_KEY) || "");
      return JSON.parse(raw || "{}") || {};
    } catch (error) {
      return {};
    }
  }

  function writeStore(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {}
    writeCookie(STORAGE_KEY, encodeURIComponent(JSON.stringify(data)), COOKIE_DAYS);
  }

  function readCookie(name) {
    try {
      var parts = String(document.cookie || "").split("; ");
      for (var i = 0; i < parts.length; i += 1) {
        var item = parts[i];
        if (item.indexOf(name + "=") === 0) return item.slice(name.length + 1);
      }
    } catch (error) {}
    return "";
  }

  function writeCookie(name, value, days) {
    try {
      var expires = new Date(Date.now() + days * 86400000).toUTCString();
      document.cookie = name + "=" + value + "; expires=" + expires + "; path=/; SameSite=Lax";
    } catch (error) {}
  }

  function captureAttribution() {
    var data = readStore();
    var params = readParams();
    var productHandle = productHandleFromPath();
    var currentUrl = safeString(window.location.href, 700);
    var currentPath = safeString(window.location.pathname + window.location.search, 700);
    var referrer = safeString(document.referrer || "", 700);
    var hasClick = hasAttributionParams(params);

    if (!data.first_landing_url) {
      data.first_landing_url = currentUrl;
      data.first_landing_path = currentPath;
      data.first_landing_at = nowIso();
    }
    if (referrer && !data.first_referrer_url) data.first_referrer_url = referrer;
    if (productHandle && !data.first_product_handle) data.first_product_handle = safeString(productHandle, 160);

    data.last_landing_url = currentUrl;
    data.last_landing_path = currentPath;
    if (referrer) data.last_referrer_url = referrer;
    if (productHandle) data.last_product_handle = safeString(productHandle, 160);

    UTM_KEYS.forEach(function (key) {
      if (!params[key]) return;
      data[key] = params[key];
      if (!data["first_" + key]) data["first_" + key] = params[key];
      data["last_" + key] = params[key];
    });

    var inferred = inferUtmProduct(productHandle);
    if (inferred && !data.utm_product) data.utm_product = inferred;
    if (inferred && !data.first_utm_product) data.first_utm_product = inferred;
    if (inferred && hasClick && !data.last_utm_product) data.last_utm_product = inferred;

    if (hasClick) {
      if (!data.first_ad_landing_url) {
        data.first_ad_landing_url = currentUrl;
        data.first_ad_landing_path = currentPath;
        data.first_ad_landing_at = nowIso();
        if (referrer) data.first_ad_referrer_url = referrer;
        if (productHandle) data.first_ad_product_handle = safeString(productHandle, 160);
      }
      data.last_ad_landing_url = currentUrl;
      data.last_ad_landing_path = currentPath;
      data.last_ad_landing_at = nowIso();
      if (referrer) data.last_ad_referrer_url = referrer;
      if (productHandle) data.last_ad_product_handle = safeString(productHandle, 160);
    }

    writeStore(data);
    return data;
  }

  function cartAttributes(data) {
    var attrs = {};
    CART_ATTRIBUTE_KEYS.forEach(function (key) {
      if (data[key]) attrs[key] = safeString(data[key], key.indexOf("url") !== -1 || key.indexOf("path") !== -1 ? 700 : 300);
    });
    return attrs;
  }

  function hashObject(obj) {
    try {
      return JSON.stringify(obj);
    } catch (error) {
      return "";
    }
  }

  function shouldSync(attrs, force) {
    if (force) return true;
    var hash = hashObject(attrs);
    var previousHash = "";
    var previousAt = 0;
    try {
      previousHash = window.sessionStorage.getItem("aw_attr_cart_hash") || "";
      previousAt = Number(window.sessionStorage.getItem("aw_attr_cart_synced_at") || 0);
    } catch (error) {}
    return hash && (hash !== previousHash || Date.now() - previousAt > SYNC_TTL_MS);
  }

  function markSynced(attrs) {
    try {
      window.sessionStorage.setItem("aw_attr_cart_hash", hashObject(attrs));
      window.sessionStorage.setItem("aw_attr_cart_synced_at", String(Date.now()));
    } catch (error) {}
  }

  function syncCartAttributes(force) {
    var data = captureAttribution();
    var attrs = cartAttributes(data);
    if (!Object.keys(attrs).length || !shouldSync(attrs, force)) return Promise.resolve(false);

    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      keepalive: true,
      body: JSON.stringify({ attributes: attrs })
    }).then(function (response) {
      if (response.ok) markSynced(attrs);
      return response.ok;
    }).catch(function () {
      return false;
    });
  }

  function bindCheckoutGuards() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") !== -1 || action.indexOf("/checkout") !== -1 || action.indexOf("/cart") !== -1) {
        syncCartAttributes(true);
      }
    }, true);

    document.addEventListener("click", function (event) {
      var link = event.target && event.target.closest ? event.target.closest("a[href*='/checkout'], a[href*='/cart']") : null;
      if (link) syncCartAttributes(true);
    }, true);

    window.addEventListener("pagehide", function () {
      syncCartAttributes(true);
    });

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") syncCartAttributes(true);
    });
  }

  function init() {
    captureAttribution();
    syncCartAttributes(false);
    bindCheckoutGuards();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.AnywellAttribution = {
    version: "20260607",
    capture: captureAttribution,
    syncCartAttributes: syncCartAttributes
  };
})();

;(() => {
  const MARKER = "aw-price-anchor-dom-cleanup-20260609";
  if (window[MARKER]) return;
  window[MARKER] = true;

  const TARGET_PATH_RE = /\/($|products\/(anywell-ys16-1-max-wide-seat-power-wheelchair|x-024-electric-mobility-scooter-with-wide-seat-for-comfortable-ride|ys12-foldable-lightweight-electric-wheelchair))/i;
  const REVIEW_REPLACEMENTS = [
    [/The foot plate is cheap and doesn(?:&#x27;|'|’)t adjust\./gi, "The foot plate feels basic and doesn't adjust."],
    [/The price, however, makes it worth it\./gi, "Overall, the chair still works for our daily routine."],
    [/cheaper too\./gi, "practical too."]
  ];

  function shouldRun() {
    return TARGET_PATH_RE.test(window.location.pathname || "/");
  }

  function hidePriceAnchors() {
    document.querySelectorAll("compare-at-price, on-sale-badge").forEach((node) => {
      node.setAttribute("aria-hidden", "true");
      node.style.setProperty("display", "none", "important");
    });
    document.querySelectorAll(".badge, [class*='badge'], [class*='price']").forEach((node) => {
      const text = (node.textContent || "").trim();
      if (/^Save\s+\d+%$/i.test(text) || /^Regular price$/i.test(text)) {
        node.setAttribute("aria-hidden", "true");
        node.style.setProperty("display", "none", "important");
      }
    });
    document.querySelectorAll("sale-price.text-on-sale").forEach((node) => {
      node.classList.remove("text-on-sale");
    });
  }

  function rewriteLowPriceReviewText(root = document.body) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const changed = [];
    let node;
    while ((node = walker.nextNode())) {
      let next = node.nodeValue || "";
      for (const [pattern, replacement] of REVIEW_REPLACEMENTS) {
        next = next.replace(pattern, replacement);
      }
      if (next !== node.nodeValue) changed.push([node, next]);
    }
    for (const [textNode, next] of changed) textNode.nodeValue = next;
  }

  function runCleanup() {
    if (!shouldRun() || !document.body) return;
    hidePriceAnchors();
    rewriteLowPriceReviewText();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runCleanup, { once: true });
  } else {
    runCleanup();
  }
  window.addEventListener("pageshow", runCleanup);
  let count = 0;
  const timer = window.setInterval(() => {
    runCleanup();
    count += 1;
    if (count >= 20) window.clearInterval(timer);
  }, 500);
})();
